import React, { useState } from "react";

const MessageA24 = (props) => {
  const [inputVal, setInputVal] = useState("");

  const [isLimitError, setIsLimitlError] = useState("");

  const maxLength = 350;

  const handleChange = (e) => {
    let value = e?.target?.value; // Trim whitespace from the input value

    console.log(value.length);

    if (value.startsWith(" ")) {
        return;
      }

      if(value.length > 350){
        setIsLimitlError("Maximum character limit is 350");
        return
      }
   

    if (value.length > 0) {
        props?.inputValue?.current?.removeAttribute("disabled");
      } else {
        console.log(value.length)
        props?.inputValue?.current?.setAttribute("disabled", true);
      }

    if (!value.startsWith(" ") && value.length >= 0) {
        setInputVal(value);
    }

    if (value.length > 350) {
      props?.inputValue?.current?.setAttribute("disabled", true);
      setIsLimitlError("Maximum character limit is 350");
    } else {
      setIsLimitlError("");
      // props?.inputValue?.current?.removeAttribute("disabled");
      localStorage.setItem(
        "inputValue",
        JSON.stringify({ key1: e.target.value })
      );
    }
  };

  return (
    <div style={{ margin: 10 }}>
      <div className="form-group">
        <input
          type="text"
          value={inputVal}
          onChange={handleChange}
          // style={{ width: "100%", boxSizing: "border-box", paddingRight: "50px" }}
          className="form-control"
          placeholder="Type here..."
        />
      </div>
      <span
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          marginTop: 10,
          fontSize: 14,
          color : 'rgb(170, 170, 170)'
        }}
      >
        Remaining: {Math.max(maxLength - inputVal.length, 0)}
      </span>
      <div
        style={{
          color: "red",
          textAlign: "center",
          marginBlockStart: 10,
          fontSize: 13,
        }}
      >
        {isLimitError && isLimitError}
      </div>
    </div>
  );
};

export default MessageA24;
